const DEFAULT_STUN_SERVERS = [{ urls: 'stun:stun.l.google.com:19302' }]

function parseIceServersFromJson(raw) {
    if (!raw) return null
    try {
        const parsed = JSON.parse(raw)
        if (!Array.isArray(parsed) || parsed.length === 0) return null
        return parsed
    } catch {
        return null
    }
}

function parseTurnServerFromEnv() {
    const urlsRaw = String(process.env.VUE_APP_WEBRTC_TURN_URLS || process.env.VUE_APP_WEBRTC_TURN_URL || '').trim()
    if (!urlsRaw) return null

    const urls = urlsRaw
        .split(',')
        .map(item => String(item || '').trim())
        .filter(Boolean)

    if (!urls.length) return null

    const username = String(process.env.VUE_APP_WEBRTC_TURN_USERNAME || '').trim()
    const credential = String(process.env.VUE_APP_WEBRTC_TURN_PASSWORD || '').trim()

    return {
        urls,
        ...(username ? { username } : {}),
        ...(credential ? { credential } : {}),
    }
}

export function getWebRtcIceServers() {
    const fromJson = parseIceServersFromJson(String(process.env.VUE_APP_WEBRTC_ICE_SERVERS || '').trim())
    if (fromJson) return fromJson

    const turnServer = parseTurnServerFromEnv()
    if (!turnServer) return DEFAULT_STUN_SERVERS

    return [...DEFAULT_STUN_SERVERS, turnServer]
}
